<div class="slider-input" #sliderInput [ngClass]="{'slider-input--dragging' : isDragging}">
  <div class="slider-input__background">
    <div class="slider-input__fill" [style]="{'width' : value * 100 + '%'}"></div>
    <div class="slider-input__handle" [style]="{'left' : value * 100 + '%'}" (mousedown)="enableDrag()">
      <span class="icon-burger"></span>
    </div>
  </div>
</div>
